const initSapTaxOldData = {
  
}

export function sapTaxOldData(
  state = initSapTaxOldData,
  action
) {
  switch (action.type) {
    case "SAP_TAX_Old_FETCH_DATA_SUCCESS":
      return action.dataSapTaxOld
    default:
      return state;
  }
}
